import React from "react";

export default ({ _, toggleAllFilters, isAllFiltersSelected }) => {
  return (
    <div className={"select-all-filters-wrapper"}>
      <button className={"filterBTN"} onClick={toggleAllFilters}>
        {isAllFiltersSelected ? _.DeselectAll : _.SelectAll}
      </button>
    </div>
  );
};
